const ZH_CN = {
    "Admin Login": "管理员登录",
    "Username": '用户名',
    "Enter Username": "输入用户名",
    "Password": "密码",
    "Enter Password": "输入密码",
    "Remember me": "记住账号",
    "Login": "登录",
    "This field is required.": "此项为必填项",
    "Error": "错误",
    "Invalid email or password": '邮箱或登录密码不正确',
    "The page you were looking for is not found!": "找不到您要查找的页面！",
    "Dashboard": "首页",
    "Member": "会员",
    "Member Details": "会员详情",
    "Lookup Sponsor": "查询推荐者",
    "Direct Downline": "直推人数",
    "Overall Team Hierarchy": "整体团队层级",
    "Member KYC": "实名认证",
    "Rank Log": "级别明细",
    "Wallet": "钱包",
    "Wallet Transaction": "钱包明细",
    "CRM Withdrawal": "CRM钱包提款",
    "CRM Deposit": "CRM存款",
    "MT5 Deposit": "MT5存款",
    "Wallet Balance": "钱包余额",
    "Wallet Adjust": '钱包调整',
    "Bonus": "奖励",
    "Lot Rebate Bonus": "点差返佣",
    "Same Rank Bonus": "平级奖",
    "Contract Commission": '合约佣金',
    "MT5": "MT5",
    "MT5 Account": "MT5账号",
    "Investment Record": "交易明细",
    "System": "系统",
    "Admin": "管理员",
    "OTC Tag List": "验证码列表",
    "Announcement": "公告",
    "Admin Dashboard": "管理员仪表板",
    "Upload Profit": "上传利润",
    "Add Admin White List IP Address": "添加管理员白名单IP地址",
    "Change Password": '更改密码',
    "Total Register Account": "总注册账户",
    "Total Deposit Account": "总存款账户",
    "Total MT5 Balance": "总MT5余额",
    "Total Wallet Balance": "总钱包余额",
    "Total Withdraw Amount": "总提款金额",
    "Personal Information": "个人信息",
    "Enter Member Email": "输入会员邮箱",
    "From": "从",
    "To": "至",
    "Download Excel": "下载Excel",
    "Status": "状态",
    "Result Per Page": "每页结果",
    "No options available": "没选项可选",
    "Register Date": "注册日期",
    "Member Email": "会员邮箱",
    "Referral Code": "邀请码",
    "Referral By": "推荐者",
    "Auto Rank": "級別（自动）",
    "Manual Rank": "級別 (手动）",
    "MT5 Balance": "MT5余额",
    "Self Deposit": "个人入金",
    "Personal Sales": "直属业绩",
    "Group Sales": "团队业绩",
    "Remark": "备注",
    "KYC Status": '实名认证状态',
    "Not Verified": "未认证",
    "Verified": "已认证",
    "Rejected": "已拒绝",
    "Approved": "已批准",
    "Edit": "更改",
    "Purchase Package": "购买配套",
    "Adjust Profit": "调整利润",
    "Topup Wallet": "充值钱包",
    "Reset Login Password": "修改登录密码",
    "Reset Trx Password": "修改交易密码",
    "Oops! No data found...": "未找到任何数据..",
    "Registration Date": "注册日期",
    "Name": "姓名",
    "Enter Name": "输入姓名",
    "Email": "邮箱",
    "Enter Email": "输入邮箱",
    "Sponsor Name": "推荐者",
    "Select Sponsor Name": "选择推荐者",
    "Select Ranking": "选择级别",
    "Date of Birth": '出生日期',
    "Select Date Of Birth": "选择出生日期",
    "Phone No": "手机号",
    "Enter Phone No": "输入手机号",
    "Country": "国家",
    "Select Country": "选择国家",
    "Address": "地址",
    "Enter Address": "输入地址",
    "Confirm": "确定",
    "Add Member": "添加会员",
    "Wallet Address": "钱包地址",
    "Enter Wallet Address": "输入钱包地址",
    "Trx Password": "交易密码",
    "Enter Trx Password": "输入交易密码",
    "Confirm Trx Password": "确认交易密码",
    "Enter Confirm Trx Password": "确认交易密码",
    "Enter Referral Code": "输入邀请码",
    "Transfer": "转移",
    "Topup": "加仓",
    "Package": "配套",
    "Select Package": "选择配套",
    "Monthly Return": "月化收益",
    "Select MT5 Account": "选择MT5账号",
    "Topup Amount": '加仓金额',
    "Select Topup Amount": "选择加仓金额",
    "Extra Profit": '额外盈利',
    "Contract Period": "合约期",
    "Select Contract Period": '选择合约期',
    "Days": "天",
    "Total Profit": "总利润",
    "Enter Total Profit": "输入总利润",
    "Total Commission": "总佣金利润",
    "Enter Total Commission": "输入总佣金利润",
    "Topup Wallet Amount": "充值金额",
    "Select Topup Wallet Amount": "选择充值金额",
    "New Login Password": "新登录密码",
    "Enter New Login Password": "输入新登录密码",
    "Confirm New Login Password": "确认新登录密码",
    "Enter Confirm New Login Password": "输入新登录密码",
    "New Trx Password": "新交易密码",
    "Enter New Trx Password": "输入新交易密码",
    "Confirm New Trx Password": "确认新交易密码",
    "Active": "已激活",
    "Inactive": "未激活",
    "KYC Verified": "实名认证已验证",
    "Attention": "请注意!",
    "Do you want to remove this member?": "您确定删除这个会员吗？",
    "Ok": "确定",
    "Cancel": "取消",
    "Success": "成功",
    "Confirm trx password need to same with new trx password": "确认交易密码需要与新交易密码相同。",
    "Confirm login password need to same with new login password.": "确认登录密码需要与新登录密码相同。",
    "Drag 'n' drop an Excel file here, or click to select one": "将Excel文件拖放到这里，或点击选择一个文件",
    "Selected file": "已选择的文件",
    "Upload": "上传",
    "Manual Update Profit": "手动更新利润",
    "Download Sample File": "下载示例文件",
    "Download": "下载",
    "Code": "代码",
    "Only Excel files (.xlsx, .xls) are accepted.": "仅接受 Excel 文件（.xlsx、.xls）。",
    "Personal CRM Deposit": "个人CRM存款",
    "Group CRM Deposit": "团队CRM存款",
    "Personal (Search By Email)": "个人(输入邮箱搜索)",
    "Group (Search By Email)": "团队(输入邮箱搜索）",
    "Transaction Date": "日期",
    "Wallet Type": '钱包类型',
    "Transaction Type": "交易类型",
    "Transaction Desc": "交易描述",
    "Amount": '金额',
    "Personal MT5 Deposit": "个人MT5存款",
    "Group MT5 Deposit": "团队MT5存款",
    "Total Downline": "团队人数",
    "Active Downline": "激活人数",
    "Total Member": "累计人数",
    "Total Active Member": "活跃人数",
    "Total Sales": "团队业绩",
    "Personal Deposit": "MT5余额",
    "Process Date": "生效时间",
    "Original Rank": "原级别",
    "New Rank": "现级别",
    "Add Admin": "添加管理员",
    "Login Username": "登录用户名",
    "Deactivate": "停用",
    "Activate": '激活',
    "Enter Login Username": "输入登录用户名",
    "Enter Login Password": "输入登录密码",
    "Login Password": "登录密码",
    "Confirm Login Password": "确认登录密码",
    "Save": '保存',
    "Edit Admin": "编辑管理员",
    "Update": "更新",
    "Do you want to deactivate this admin?": '您想停用此管理员吗？',
    "Do you want to activate this admin?": "您想激活此管理员吗？",
    "Password must at least 6 characters": "密码必须至少为6个字符",
    "Confirm password need to same with password": "确认密码需要与密码相同",
    "Run Lot Rebate Bonus": "运行点差返佣奖金",
    "Run Profit Sharing Bonus": "运行盈利分润奖金",
    "Run": "运行",
    "Generate Fake Trade Record": "生成虚假交易记录",
    "Select Date": "选择日期",
    "Change Percentage For Fake Trade Record": "更改虚假交易记录的百分比",
    "Percentage For Generate Trade Record": "交易记录的百分比",
    "Change Exchange Rate": "更改汇率",
    "Exchange Rate System Get": "汇率系统获取",
    "Exchange Rate Manually Set": "手动设置汇率",
    "If 0 Then Use Exchange Rate System Get": "如果为0，则使用汇率系统获取",
    "Run Up Rank": "运行排名",
    "Run Get Mt5 Deal Task": "运行获取MT5交易任务",
    "Run Calculate Member Sales": "运行计算会员销售",
    "Old Password": "当前密码",
    "New Password": "新密码",
    "Enter Old Password": "输入当前密码",
    "Enter New Password": "输入新密码",
    "Confirm Password": "确认密码",
    "Enter Confirm Password": "输入确认密码",
    "Tag Usage": "使用类型",
    "register": "注册",
    "otp_pending": "待处理",
    "otp_completed": "已使用",
    "otp_expired": "已逾期",
    "withdraw": "提款",
    "Tag": "验证码",
    "Add New White List IP": "添加新的白名单IP",
    "Created Date": "创建日期",
    "IP Address": "IP地址",
    "Description": "描述",
    "White List IP": "白名单IP",
    "Enter IP Address": "输入IP地址",
    "Enter Description": "输入描述",
    "Personal Withdraw": "个人提款",
    "Group Withdraw": "团队提款",
    "All": "全部",
    "Doc No": "编号",
    "Submit Date": "提交日期",
    "Submit Amount": "提交金额",
    "Withdraw Type": "提款类型",
    "Fee": "手续费",
    "Fee In Fiat": "法币手续费",
    "Rate": "汇率",
    "Receive Currency": "到账货币",
    "Receive Amount": "到账金额",
    "wallet_active": "已批准",
    "wallet_pending": "待处理",
    "wallet_approved": "已批准",
    "wallet_rejected": "已拒绝",
    "Approve": "批准",
    "Reject": "拒绝",
    "Wallet Withdrawal Details": "提款详情",
    "Crypto Section": "加密货币详情",
    "TxHash / Bank Reference Id": "TxHash / 银行参考ID",
    "Chain Type": "网络类型",
    "Enter Remark": "输入备注",
    "Confirm approve this request?": "确认批准此请求吗？",
    "Confirm reject this request?": "确认拒绝此请求吗？",
    "Wallet Balance List": "钱包余额列表",
    "Total Balance": "钱包余额",
    "Full Name": "姓名",
    "Wallet Transaction List": "钱包明细列表",
    "CRM In (Deposit)": "CRM入金（存款）",
    "CRM Out (Withdraw)": "CRM出金（提现）",
    "MT5 In (Deposit)": "MT5入金（存款）",
    "MT5 Out (Withdraw)": "MT5出金（提现）",
    "Total Bonus": "佣金",
    "Profit Sharing": "交易盈利",
    "Re-Invest": "复投",
    "Total Lot Size": "总手数",
    "Adjust (Dummy Account)": "调整（虚拟账户）",
    "MT5 Out (Member)": "MT5 转出（会员）",
    "In Amount": "转入金额",
    "Out Amount": "转出金额",
    "Adjust Type": "类型",
    "IN": "转入",
    "OUT": "转出",
    "Loading Data": "加载数据中",
    "Logout": "登出",
    "Id No": "身份证号",
    "Front Image": "证件正面",
    "Back Image": "证件反面",
    "Hold Image": "手持证件",
    "Verify Date": "审核日期",
    "Reject Reason": "拒绝原因",
    "Do you want to approve this member?": "您确定批准这个会员吗？",
    "Do you want to reject this member?": "您确定拒绝这个会员吗？",
    "Pending": "审核中",
    "Submit": "提交",
    "CRYPTO_WITHDRAW": "加密货币提款",
    "FIAT_WITHDRAW": "法币提款",
    "View": "查看",
    "Process By": "操作者",
    "Lot Rebate List": "点差返佣记录",
    "Personal Bonus": "个人返佣",
    "Group Bonus": "团队返佣",
    "Trx Date": "日期",
    "Profit From": "结算用户",
    "Lot Size": "手数",
    "Lot Rebate": "点差返佣",
    "Same Rank Bonus List": "平级奖记录",
    "MT5 Account List": "MT5账号记录",
    "Total MT5 Amount": "总金额(MT5)",
    "Personal (Search By Email / MT5 ID)": "个人 (输入邮箱/MT5账号搜索)",
    "Group (Search By Email / MT5 ID)": "团队 (输入邮箱/MT5账号搜索)",
    "E A": "跟单 E A",
    "Member Name": "姓名",
    "MT5 Password": "MT5密码",
    "MT5 ID": "MT5账号",
    "MT5 Group": "MT5组别",
    "Copy Trade Lot": "交易手数",
    "Max Lot": "结算手数",
    "Trx Date Time": "日期",
    "Product Lot": "手数",
    "Pipe Bonus Status": "佣金状态",
    "Profit Sharing Status": "盈利状态",
    "MT5 Deal ID": "MT5交易ID",
    "Settlement No": "结算号",
    "Position ID": "持仓ID",
    "Profit": "利润",
    "Commission": "佣金",
    "Rate Profit": "利润率",
    "Rate Margin": "保证金率",
    "Market Bid": "市场买价",
    "Market Ask": "市场卖价",
    "Max Lot Per Week Status": "每周最大手数状态",
    "Price": "价格",
    "Enter Amount": "输入金额",
    "Add Announcement": "添加公告",
    "Title (English)": "标题 (英文)",
    "Title (Chinese)": "标题（中文）",
    "Description (English)": "内容 (英文)",
    "Description (Chinese)": "内容（中文）",
    "Enter Description (Chinese)": "输入内容（中文）",
    "Enter Description (English)": "输入内容 (英文)",
    "Enter Title (English)": "输入标题（英文）",
    "Enter Title (Chinese)": "输入标题（中文）",
    "Date": "日期",
    "MT5 Login": "MT5 登录",
    "MT5 Profit": "MT5盈利",
    "MT5 Volume": "MT5 量",
    "MT5 Name": "MT5 姓名",
    "No Result Found": '没有找到结果',
    "No data for download": "没有数据可供下载",
    "View Excel File": "查看Excel文件",
    "View Profit": "查看利润",
    "WITHDRAW": "钱包提款",
    "DEPOSIT_CRM": "钱包充值",
    "DEPOSIT_MT5": "MT5充值",
    "Early Bird Bonus": "早鸟收益",
    "VIP Bonus": "VIP收益",
    "Action": "操作",
    "Profit Sharing Bonus": "盈利分润",
    "Same Rank Percentage": "平级百分比",
    "Enter Topup Amount": "输入充值金额",
    "Used Date": "使用日期",
    "Investment Allocation": "仓位金额",
    "Total": "总计",
    "Personal Same Rank Bonus": "个人平级奖",
    "Group Same Rank Bonus": "团队平级奖",
    "Personal Contract Commission": "个人合约佣金",
    "Group Contract Commission": "团队合约佣金",
    "Total Balance (Personal)": "个人钱包余额",
    "Total Balance (Group)": "团队钱包余额",
    "Receive": "到账",
    "TRANSFER_FROM_MT5": "MT5提款",
    "Self Withdraw": "个人出金",
    "news_active": "活跃",
    "news_inactive": "不活跃",
    "Rank": "级别",
    "change_transaction_password": "修改交易密码",
    "change_password": "修改登录密码",
    "Rank Type": "级别操作",
    "downgrade": "降级",
    "upgrade": "升级",
    "Hedge Position": "对冲仓视频",
    "Period Extra Profit": "合约期收益",
    "Personal Period Extra Profit": '个人合约期收益',
    "Group Period Extra Profit": '团队个人合约期收益',
    "TRC20 Chain": "TRC20网络 ",
    "Copy": "复制",
    "Copied": "已复制",
    "Personal Early Bird Bonus": "个人早鸟收益",
    "Group Early Bird Bonus": "团队早鸟收益",
    "Personal VIP Bonus": "个人VIP奖励",
    "Group VIP Bonus": "团队VIP奖励",
    "Early Bird Bonus Type": '收益类型',
    "CRM Wallet": "CRM 钱包",
    "MT5 Wallet": "MT5 钱包",
    "Select Action": "选择操作",
    "forget_password": "重置登录密码",
    "Purchase Package History": "购买配套记录",
    "Purchase Datetime": "购买日期",
    "Cumulative Investment Days": "累计跟单天数",
    "Total MT5 Amount (Personal)": "个人总MT5金额",
    "Total MT5 Amount (Group)": "团队总MT5金额",
    "ADJUST": "调整",
    "Modify By": "修改者",
    "COPY EA MT5 ID": "跟单EA",
    "EA Status": "跟单状态",
    "Enter Member MT5 Login": '输入会员MT5 登录',
    "Dummy Account": "虚拟账户",
    "Deleted": "已关闭",
    "New Announcement": "新公告",
    "Title": "标题",
    "Enter title": "输入标题",
    "Please fill in announcement for at least one language": "请填写至少一种语言的公告",
    "Edit Announcement": "编辑公告",
    "Delete": "删除",
    "Add Hedge Position": "添加对冲仓视频",
    "New Hedge Position": "新对冲仓视频",
    "Edit Hedge Position": "编辑对冲仓视频",
    "Recommended Size": "推荐尺寸",
    "Cover Image": "封面图片",
    "Video": "视频",
    "Upload Image": "上传图片",
    "Announcement not found": "公告不存在",
    "Hedge Position not found": "对冲仓视频不存在",
    "Please fill in hedge position for at least one language": '请填写至少一种语言的对冲仓视频',
    "Select Video": "选择视频",
    "Video Uploaded": '已上传视频',
    "Select New Video": "选择新视频",
    "Attachment is uploading": '附件正在上传中',
    "Total In (Adjust)": "总入金（调整）",
    "Total Out (Adjust)": "总出金（调整）",
    "Personal Mt5 Profit": "个人MT5盈利",
    "Group Mt5 Profit": "团队MT5盈利",
    "Role": "角色",
    "Permission": "权限",
    "Permission List": "权限列表",
    "Operation Permission": "操作权限",
    "Page Permission": "查询权限",
    "User": "管理员",
    "Setting": "设置",
    "Select All": "全选",
    "Edit Permission": "更改权限",
    "Add New Permission": "添加新的权限",
    "Role Name": "角色名称",
    "Enter Role Name": "输入角色名称",
    "User Role": "用户角色",
    "Select User Role": "选择用户角色",
    "Customer": "会员",
    "User Type": "用户类型",
    "Action Type": "动作类型",
    "Admin Journal": "行政日志",
    "Enter Email/Username": "输入会员邮箱/管理员用户名",
    "Shareholder": "提款系统",
    "Add Shareholder": "添加股东",
    "User Group": "用户组",
    "Early Bird Package": "早鸟配套",
    "VIP Package": "VIP配套",
    "Company Customer Profit Sharing": "公司客户利润分享",
    "Configuration": "配置",
    "Package Amount": "配套金额",
    "MT5 Amount": "MT5金额",
    "Hedge Amount": "对冲金额",
    "High Lot": "最高手数",
    "Low Lot": "最低手数",
    "High ROI": "最高投资回报率",
    "Low ROI": "最低投资回报率",
    "Account": "账户",
    "Group Name": "群组名称",
    "Commission Rate": "佣金率",
    "Upline Commission Rate": "上线佣金率",
    "Total Account": "总账户",
    "Company": "公司",
    "Enter Company Profit": "输入公司利润",
    "Enter Customer Profit": "输入客户利润",
    "Penalty Rate": "违约率",
    "Total profit percentage must equal to 100": "总利润百分比必须等于100",
    "Early Bird Name": "早鸟配套",
    "VIP Name": "VIP配套",
    "Rank Name": "级别名称",
    "Rank Icon": "级别图标",
    "MT5 Balance Target": "MT5余额目标",
    "Personal Sales Target": "直推业绩目标",
    "Group Sales Target": "团队业绩目标",
    "Contract Commission Rate": "合约佣金率",
    "Same Rank Rate": "平级津贴率",
    "Select Setting Type": "选择设置类型",
    "Please select setting": "请选择设置",
    "Login Type": "登录类型",
    "Enter": "输入",
    "Company Name": "公司名称",
    "Withdrawal No.": "提款编号",
    "Network Fee": "网络费用",
    "TRX Transfer Amount": 'TRX转账金额',
    "Minimum USDT Transfer Amount": "最低USDT转账金",
    "Main Admin ID": "主管理员 ID",
    "Company ID": "公司ID",
    "Ignore MT5 Login IDs": "忽略 MT5 登录 ID",
    "Main TRX Account": "主TRX账户",
    "Public Key": "公钥",
    "Private Key": '私钥',
    "base58 Address": 'base58 地址',
    "HEX Address": 'HEX 地址',
    "MT5 Dummy Accounts": "MT5 虚拟账户",
    "Customer Dummy Accounts": '客户虚拟账户',
    "MT5 Current Login ID": 'MT5当前登录ID',
    "Select User Group": "选择用户组",
    "Balance": "余额",
    "Enter Balance": "输入余额",
    "Total USDT to Distribute": "待分配的 USDT 总额",
    "Percentage": "百分比",
    "Enter Percentage": '输入百分比',
    "Add Data": "添加数据",
    "Only accept *.mp4, *flv format file": "仅接受 mp4, webm, ogg, avi, mov, wmv, flv, mkv 格式视频",
    "Add New Wallet Address": "添加新钱包地址",
    "New Admin": "新管理员",
    "Add New Admin": "添加新管理员",
    "Admin_Deleted": "已停用",
    "Add New Data": "添加新数据",
    "Commission Rate Type": "佣金类型",
    "Upline Commission Rate Type": "上线佣金类型",
    "Penalty Rate Type": "违约率类型",
    "Same Rank Rate Type": "平级津贴率类型",
    "Contract Commission Rate Type": "合约佣金类型",
    "Special Account": "早鸟配套/VIP配套列表",
    "Special Account Type": "早鸟配套/VIP配套",
    "Special Account List": "早鸟配套/VIP配套列表",
    "Early Bird Bonus Package": "早鸟配套",
    "VIP Bonus Package": "VIP配套",
    "Add Special Account": "添加配套",
    "Change Contract Period": "更改合约期",
    "Current Contract Period": '当前合约期',
    "New Contract Period": '新合约期',
    "Order ID": "订单号",
    "Trading Pair": "产品名称",
    "Profit/Loss %": "盈利/亏损",
    "Price Enter": "入场价格",
    "Price Close": "出场价格",
    "completed": "完成",
    "Buy": "买",
    "Sell": "卖",
    "Start Date": "开始日期",
    "Total Earning Bonus": "总收益",
    "Admin Account Setting": "管理员账号设置",
    "Details": "详情",
    "Data Change": "更改数据",
    "Do you want to stop this VIP/Early Bird Package?": "您想停止此早鸟配套/VIP配套吗",
    "Do you want to activate this VIP/Early Bird Package?":  "您想激活此早鸟配套/VIP配套吗",
    "Stop": "停止",
    "Invalid amount": '余额无效',
    "Edit Special Account": "更改早鸟配套/VIP配套",
    "Remaining Period":"剩余周期",
    "Enter Remaining Period": '输入剩余周期',
    "Select MT5 Group": "选择MT5组别",
    "Edit MT5 Account": '编辑MT5账号',
    "Distribute to Shareholder": '添加提款到账地址',
    "package_deleted": "已停止",
    "package_active": "已激活",
    "Contract Commission Percentage": "合约佣金百分比",
    "Package Performance": "配套业绩",
    "Commission Percentage": "佣金百分比",
    "Contract Commission Same Rank Bonus Percentage": "合约佣金平级奖百分比",
    "Back To Login": "返回登录",
    "Welcome back,": "欢迎回来，",
    "We are sorry": "很抱歉",
    "The page you're trying to access has restricted access. Please refer to your system administrator.": "您尝试访问的页面访问权限受到限制。请咨询您的系统管理员。",
    "Profit Sharing Remark": "交易盈利备注",
    "Profit Sharing Bonus List": "盈利分润",
    "Personal Profit Sharing Bonus": "个人盈利分润",
    "Group Profit Sharing Bonus": "团队盈利分润",
    "Select Profit Sharing": "选择公司客户利润分享",
    "1000 USD Max Lot Per Month": "每月最大手数1000美元",
    "Enter 1000 USD Max Lot Per Month": "输入每月最大手数1000美元",
    "Live Trade": "实时交易视频",
    "Add Live Trade": "添加实时交易视频",
    "Edit Live Trade": "编辑实时交易视频",
    "No data to export": "没有数据可导出",
    "Txn Hash": "交易哈希",
    "Enter Txn Hash": "输入交易哈希",
    "Received Wallet Address": "到账地址",
    "Network": "网络",
    "Select Network": "选择网络",
    "BEP20 Chain": "BEP20网络",

    "Rank ID": "级别ID",
    "Rank Image": "级别图片",
    "Upload Rank Image": "上载级别图片",
    "Same Rank": "同级",
    "Reset": "重置",
    "Edit Custom Rank": "编辑自定义级别",
    "Add Custom Rank": "添加自定义级别",
    "Enter Custom Rank Name": "输入自定义级别名称",
    "Custom Rank": "自定义级别",
    "New Custom Rank": "新自定义级别",
    "Custom Rank Name": "自定义级别名称",
    "Select Custom Rank": "选择自定义级别",
    "Enter Lot Size": "输入手数",
    "Enter Rank ID": "输入级别ID",
    "Enter Rank Name": "输入级别名称",
    "Enter MT5 Balance Target": "输入MT5余额目标",
    "Enter Personal Sales Target": "输入直推业绩目标",
    "Enter Group Sales Target": "输入团队业绩目标",
    "Enter Rate": "输入数额",
    "Select Status": "选择状态",
    "Select Type": "选择类别",
    "Add Rank": "添加级别",
    "Edit Rank": "编辑级别",
    "Edit User Group": "编辑用户组",
    "Add User Group": "添加用户组",
    "MT5 Group ID": "MT5组ID",
    "User Group Name": "用户组名称",
    "Edit Profit Sharing": "编辑交易盈利",
    "Add Profit Sharing": "添加交易盈利",
    "Profit Sharing ID": "交易盈利ID",
    "Enter Profit Sharing ID": "输入交易盈利ID",
    "Profit Sharing Name": "交易盈利名称",
    "Default": '默认',
    "Enter Profit Sharing Name": "输入交易盈利名称",
    "Label Name": "名称",
    "Yes": "是",
    "No": "否",
    "Value": "数值",
    "Type": "类别",
    "Value must equal or larger than 0": "数值必须等于或大于 0",
    "Enter Value": "输入数值",
    "Select Default": "选择默认",
    "Main USDT Account": "主USDT账户",
    "Main BSC Account": "主BSC账户",
    "Main BSC USDT Account": "主BSC USDT账户",
    "Minimum BNB Transfer Amount": "BNB 最低转账金额",
    "Main USDT Wallet USDT Balance": "主USDT钱包USDT余额",
    "Main BSC USDT Wallet USDT Balance": "主BSC USDT钱包USDT余额",
    "Main USDT Wallet TRX Balance": "主要USDT钱包TRX余额",
    "Enter Withdrawal No.": "输入提款编号",
    "Trading Statistic": "交易数据概览",
    "Coverage Region": "覆盖国家",
    "Edit Coverage Region": "编辑覆盖国家",
    "Add Coverage Region": "添加覆盖国家",
    "Assets Under Management": "带单规模",
    "Total Trades": "总带单笔数",
    "Win Trades": "总盈利笔数",
    "Lose Trades": "总亏损笔数",
    "Max Drawdown": "最大回撤",
    "Please choose a profit sharing as default": "请选择默认利润分享",
    "Profit Sharing Percentage": "利润分享比例",
    "Profit Sharing Same Rank Bonus Percentage": "利润分享同等级奖金百分比",
    "Member Rank Error": '会员级别错误',
    "Edit User Rank": "编辑会员级别",
    "Close": "关闭",
    "Deposit MT5": "充值MT5",
    "Fiat Section": "法币详情",
    "Bank Name": "银行名字",
    "Bank Account Name": "银行户口姓名",
    "Bank Account No.": "银行户口号码",
    "Profit Sharing Bonus2" :"交易盈利佣金",
    "View Member Team Hierarchy": "查看会员团队层级",
    "Select Member": "选择会员",
    "Total Transfer (In)": "总转账（入）",
    "Total Transfer (Out)": "总转账（出）",
    "Copy Strategies": "跟单策略",
    'Select Copy Strategies': '选择跟单策略',
    "Transfer Package": "转移",
    "Minimum investment amount is $amount": "最低划转金额为 $amount",
    "Maximum investment amount is $amount": "最高划转金额为 $amount",
    "5,000 and above": "5,000及以上",
    "Trading Profit (Month)": "交易收益(月)",
    "Date & Time": "时间",
    "Doc No.": "订单号",
    "MT5 Transfer to Wallet": "MT5提款至钱包",
    "Day Count": '天数',
    "Handling Fee": "手续费",
    "View Details": "查看详情",
    "Request wallet withdraw": '钱包提款',
    "Assets Type": "资产类型",
    "Target User": "目标用户",
    "Internal Transfer": "转账",
    "Personal MT5 Withdraw": "个人MT5提款",
    "Group MT5 Withdraw": "团队MT5提款",
    "Member ID": "会员 ID",
    "Enter Profit": "输入利润",
    "Enter Lot Size": "输入手数",
    "Daily": "每日",
    "Weekly": "每周",
    "Type": "类型",
    "(NO CAPPED - based on the lot size provided)": "（无上限 - 根据提供的手数）",
    "Run MT5 Profit": "运行 MT5 利润",
    "Confirmation": "确认",
    "This profit did not deduct the 20% for company.": "此利润未扣除公司 20%.",
    "eg: mt5 account": "eg: MT5金额",
    "Block Withdrawal Customer IDs": "阻止提款客户 IDS",
}

export default ZH_CN;